import { useCallback, useEffect, useState } from "react";
import useDebounce from "shared/hooks/useDebounce";
import { usePaginationState } from "shared/hooks/usePaginationState";

type Params = {
  defaultPageSize?: number;
  defaultAllPageSize?: number;
  /** При смене справочника поиск и обе пагинации сбрасываются. */
  resetKey?: string | null | undefined;
};

const SEARCH_DEBOUNCE_MS = 400;

/**
 * Страница справочника показывает две таблицы — записи сервиса и все доступные, —
 * поэтому пагинаций две, а поиск на обе один.
 */
export function useHandbookSearchPagination({
  defaultPageSize = 10,
  defaultAllPageSize = 10,
  resetKey,
}: Params) {
  const main = usePaginationState(defaultPageSize);
  const all = usePaginationState(defaultAllPageSize);

  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, SEARCH_DEBOUNCE_MS);

  const resetMain = main.reset;
  const resetAll = all.reset;

  useEffect(() => {
    resetMain();
    resetAll();
    setSearch("");
  }, [resetKey, resetMain, resetAll]);

  const goToFirstMain = main.goToFirstPage;
  const goToFirstAll = all.goToFirstPage;

  const handleChangeSearch = useCallback(
    (value: string) => {
      goToFirstMain();
      goToFirstAll();
      setSearch(value);
    },
    [goToFirstMain, goToFirstAll],
  );

  return {
    pagination: main.pagination,
    allDictPagination: all.pagination,
    search,
    debouncedSearch,
    handleChangeSearch,
    handlePageChange: main.handlePageChange,
    handleAllDictPageChange: all.handlePageChange,
  };
}
